import { Injectable } from "@angular/core";
import { Modules, Permissions } from "../interfaces/permissions.api.interface";
import { SessionService } from "../session/session.service";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class MenuConfig {


  //Third Submenu Locations
  configurationLocalitiesModules: IMenuItem[] = [
    { name: 'configurationLocalitiesCountries', routerLink: ['/countries'], icon: '', childItems: [], permissions: [{module: Modules.Countries, permission: Permissions.List }] },
    { name: 'configurationLocalitiesRegions', routerLink: ['/regions'], icon: '', childItems: [] , permissions: [{module: Modules.Regions, permission: Permissions.List}]  },
    { name: 'configurationLocalitiesCities', routerLink: ['/cities'], icon: '', childItems: [] , permissions: [{module: Modules.Cities, permission: Permissions.List}]  }
  ]


  //Third Submenu Lista de maestros
  configurationMasterDataModules: IMenuItem[] = [
    { name: 'configurationMasterDataSupportCategories', routerLink: ['/supportCategories'], icon: '', childItems: [], permissions: [{module: Modules.SupportCategories, permission: Permissions.List }] },
    { name: 'configurationMasterDataSupportStates', routerLink: ['/supportStates'], icon: '', childItems: [], permissions: [{module: Modules.SupportStates, permission: Permissions.List }] },
  ]

  //Third Submenu Envases Reutilizables
  configurationPackagingModules: IMenuItem[] = [
    { name: 'configurationSuppliers', routerLink: ['/suppliers'], icon: '', childItems: [], permissions: [{module: Modules.Suppliers, permission: Permissions.List}] },
    { name: 'configurationContainerCategories', routerLink: ['/containerCategories'], icon: '', childItems: [], permissions: [{module: Modules.ContainerCategories, permission: Permissions.List}] },
    { name: 'configurationColors', routerLink: ['/colors'], icon: '', childItems: [], permissions: [{module: Modules.Colors, permission: Permissions.List}] },
    { name: 'configurationWasteTypes', routerLink: ['/wasteTypes'], icon: '', childItems: [], permissions: [{module: Modules.WasteTypes, permission: Permissions.List}] },
    { name: 'configurationEanCodes', routerLink: ['/eanCodes'], icon: '', childItems: [], permissions: [{module: Modules.EanCodes, permission: Permissions.List}] },
    // Solo en entornos no productivos (flag environment.showTestLabels)
    ...(environment.showTestLabels ? [{ name: 'configurationTestLabels', routerLink: ['/testLabels'], icon: '', childItems: [], permissions: [{module: Modules.EanCodes, permission: Permissions.List}] }] : []),
  ]

  //Submenu configuración
  configurationModules: IMenuItem[] = [
    { name: 'configurationUsers', routerLink: ['/users'], icon: '', childItems: [] , permissions: [{module: Modules.Users, permission: Permissions.List}]  },
    { name: 'configurationRoles', routerLink: ['/roles'], icon: '', childItems: [] , permissions: [{module: Modules.Roles, permission: Permissions.List}] },
    { name: 'configurationContainers', routerLink: ['/containers'], icon: '', childItems: [] , permissions: [{module: Modules.Containers, permission: Permissions.List}] },
    { name: 'configurationPackaging', routerLink: null, icon: '', childItems: this.configurationPackagingModules, permissions: [
      {module: Modules.Suppliers, permission: Permissions.List},
      {module: Modules.ContainerCategories, permission: Permissions.List},
      {module: Modules.Colors, permission: Permissions.List},
      {module: Modules.WasteTypes, permission: Permissions.List},
      {module: Modules.EanCodes, permission: Permissions.List},
    ]},
    { name: 'configurationClients', routerLink: ['/clients'], icon: '', childItems: [] , permissions: [{module: Modules.Clients, permission: Permissions.List}] },
    { name: 'configurationLocations', routerLink: ['/locations/list'], icon: '', childItems: [] , permissions: [{module: Modules.Locations, permission: Permissions.List}] },
    { name: 'configurationLocalities', routerLink: ['/countries'], icon: '', childItems: this.configurationLocalitiesModules ,  permissions: [{module: Modules.Countries, permission: Permissions.List}, {module: Modules.Regions, permission: Permissions.List}, {module: Modules.Cities, permission: Permissions.List}]  },
    { name: 'configurationMasterData', routerLink: ['/supportCategories'], icon: '', childItems: this.configurationMasterDataModules , permissions: [{module: Modules.SupportCategories, permission: Permissions.List}, {module: Modules.SupportStates, permission: Permissions.List}]  },
  ]

  /*Array menu principal */
  menuModules: IMenuItem[] = [
    { name: 'home', routerLink: ['/index'], icon: 'icon_home.png', iconStyle:'menu-icon', childItems: [], permissions: []},
    {name: 'packagings', routerLink: ['/packagings'], icon: 'icon_recovery.png', iconStyle:'menu-icon', childItems: [], permissions: [{module: Modules.Packagings, permission: Permissions.List}]},
    {name: 'usersClients', routerLink: ['/usersClients'], icon: 'icon_users.png', iconStyle:'menu-icon', childItems: [], permissions: [{module: Modules.UsersClients, permission: Permissions.List}]},
    { name: 'menuSectionManagement', routerLink: null, icon: '', childItems: [], isDivider: true, permissions: [
      {module: Modules.SupportTickets, permission: Permissions.List}, {module: Modules.SupportTickets, permission: Permissions.ListOwn},
      {module: Modules.Users, permission: Permissions.List}, {module: Modules.Countries, permission: Permissions.List}, {module: Modules.Regions, permission: Permissions.List},
      {module: Modules.Cities, permission: Permissions.List}, {module: Modules.Roles, permission: Permissions.List},
      {module: Modules.Locations, permission: Permissions.List}, {module: Modules.Clients, permission: Permissions.List},
      {module: Modules.Containers, permission: Permissions.List}, {module: Modules.SupportCategories, permission: Permissions.List},
      {module: Modules.SupportStates, permission: Permissions.List},
    ]},
    {name: 'support', routerLink: ['/support'], icon: 'icon_support.svg', iconStyle:'menu-icon', childItems: [], permissions: [{module: Modules.SupportTickets, permission: Permissions.List}, {module: Modules.SupportTickets, permission: Permissions.ListOwn}]},
    { name: 'configuration', routerLink: null, icon: 'icon_config.png', iconStyle:'menu-icon', childItems: this.configurationModules , permissions: [
      {module: Modules.Users, permission: Permissions.List}, {module: Modules.Countries, permission: Permissions.List}, {module: Modules.Regions, permission: Permissions.List},
      {module: Modules.Cities, permission: Permissions.List}, {module: Modules.Roles, permission: Permissions.List},
      {module: Modules.Locations, permission: Permissions.List}, {module: Modules.Clients, permission: Permissions.List},
      {module: Modules.Containers, permission: Permissions.List}, {module: Modules.SupportCategories, permission: Permissions.List},
      {module: Modules.SupportStates, permission: Permissions.List},
      {module: Modules.Suppliers, permission: Permissions.List},
      {module: Modules.ContainerCategories, permission: Permissions.List},
      {module: Modules.Colors, permission: Permissions.List},
      {module: Modules.WasteTypes, permission: Permissions.List},
      {module: Modules.EanCodes, permission: Permissions.List},
    ]}

  ];

  /**
   * Devuelve los modulos de la aplicación
   */
  private GetModules(): IMenuItem[] {
    return this.menuModules;
  }

  /**
   * Devuelve las opciones de menu disponibles para un usuario
   */
  public GetMenuOptions(sessionService: SessionService): IMenuItem[] {
    var options = this.GetModules();

    if (sessionService.isLoggedIn()) {
      var userRoles = sessionService.user.ListPermissions;
      options = options.filter(item => {
        return (item.permissions.length == 0 || userRoles.find(o => item.permissions.find(x => x.module == o.module && o.permissions.includes(x.permission)))) && ((!item.session) || (item.session === 'with'));
      });
    } else {
      options = options.filter(item => (!item.session || item.session === 'without'));
    }

    return options;
  }

  /**
   * Devuelve las opciones de un submenu disponibles para un usuario
   */
  public GetSubMenuOptions(sessionService: SessionService, menuSelected: IMenuItem): IMenuItem[] {
    var options = menuSelected.childItems;

    if (sessionService.isLoggedIn()) {
      var userRoles = sessionService.user.ListPermissions;
      options = options.filter(item => {
        return (item.permissions.length == 0 || userRoles.find(o => item.permissions.find(x => x.module == o.module && o.permissions.includes(x.permission)))) && ((!item.session) || (item.session === 'with'));
      });
    } else {
      options = options.filter(item => (!item.session || item.session === 'without'));
    }

    options.forEach(item => {
      if (item.childItems != null && item.childItems.length > 0){
        item.childItems = item.childItems.filter(subItem => {
          return (item.permissions.length == 0 || userRoles.find(o => subItem.permissions.find(x => x.module == o.module && o.permissions.includes(x.permission)))) && ((!subItem.session) || (subItem.session === 'with'));
        });
      }
    });

    return options;
  }

  /**
   * Devuelve las opciones de menu disponibles para un usuario logeado
   */
  public GetFirstMenuOptions(sessionService: SessionService): IMenuItem {
    var options = this.GetModules();
    const isAdmin = sessionService.isAdmin();
    var userRoles = sessionService.user.ListPermissions;

    options = options.filter(item => {
      return (isAdmin || item.permissions.length == 0 || userRoles.find(o => item.permissions.find(x => x.module == o.module && o.permissions.includes(x.permission)))) && ((!item.session) || (item.session === 'with'));
    });

    var firstOption = options[0];

    //Si tiene elementos de segundo nivel, buscamos la primera opción en el nivel
    if (firstOption != null && firstOption.childItems != null && firstOption.childItems.length > 0){
      var secondLevelOptions = firstOption.childItems.filter(item => {
        return ((isAdmin) || userRoles.find(o => item.permissions.find(x => x.module == o.module && o.permissions.includes(x.permission)))) && ((!item.session) || (item.session === 'with') );
      });
      firstOption = secondLevelOptions != null && secondLevelOptions.length > 0 ? secondLevelOptions[0] : firstOption;
    }

    return firstOption;
  }


  public hasChildItems(menuItem: IMenuItem)
  {
    return menuItem.childItems != null && menuItem.childItems.length > 0
  }

  public GetLiClass(menuItem: IMenuItem) : string
  {
    return this.hasChildItems(menuItem) ? "dropdown-menu dropdown-menu-default dropdown-user-responsive" : "";
  }

  public GetLiAttr(menuItem: IMenuItem) : string
  {
    return this.hasChildItems(menuItem) ? "dropdown-menu dropdown-menu-default dropdown-user-responsive" : "";
  }


}

export interface IMenuItem {
  name: string;
  shortName?: string;
  routerLink: any[];
  session?: 'with' | 'without';
  icon: string;
  iconStyle?: string;
  childItems: IMenuItem[];
  permissions: IMenuPermission[];
  /** Si es true, el elemento es solo un separador/etiqueta de sección (no navegable) */
  isDivider?: boolean;
}

export interface IMenuPermission {
  module: number;
  permission: number;
}
